import React from "react";
import Layout from "../components/Layout";
import PageIntro from "../components/PageIntro";
import PromoGrid from "../components/home/PromoGrid";
import { getActivePromotions, PROMOTIONS_FOOTNOTE } from "../data/promotions";

/**
 * Listado completo de promociones vigentes, al que lleva el botón
 * "Ver todas las promociones" de la home.
 */
const Promociones = () => {

	const promotions = getActivePromotions();

	return (
		<Layout>
			<PageIntro
				eyebrow="Belimport"
				title="Promociones vigentes"
				aside={ `${promotions.length} vigentes` }
			/>

			{
				promotions.length === 0
					? <p className="text-sm text-muted">Por el momento no hay promociones vigentes.</p>
					: (
						<>
							<PromoGrid promotions={ promotions } />
							<p className="mt-7 max-w-[620px] text-xs leading-relaxed text-muted">{ PROMOTIONS_FOOTNOTE }</p>
						</>
					)
			}
		</Layout>
	);
};

export default Promociones;
